import { createContext } from "react";
import type { ButtonProps } from "./Button";

export const ButtonContext = createContext<
  {
    size: ButtonProps["size"];
  } | null
>(null);
